var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62582 0H13.5755C15.0197 0 16.2013 1.14711 16.2013 2.60708V11.3929C16.2013 12.8268 15.0197 14 13.5755 14H2.62582C1.18162 14 0 12.8268 0 11.3929V2.60708C0 1.17318 1.18162 0 2.62582 0ZM21.6105 1.61639C21.7418 1.53817 21.8993 1.45996 22.0569 1.43389C23.081 1.19926 24 1.98138 24 2.946V11.0019C24 11.2886 23.9212 11.5493 23.7899 11.784C23.3435 12.54 22.3982 12.8007 21.6368 12.3575L17.5142 10.0112V3.96276L21.6105 1.61639Z",
    fill: "#292F4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.c4ff77f169c265ac13bebcad2b169ff0.svg";
export { ForwardRef as ReactComponent };